(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor(){ super(); }
    connectedCallback(){
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky){ this.header.classList.add('shopify-section-header-sticky'); }
      this.currentScrollTop = 0; this.preventReveal = false; this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight(){ document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`); }
    disconnectedCallback(){ this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp); window.removeEventListener('scroll', this.onScrollHandler); }
    createObserver(){ let o = new IntersectionObserver((e,ob)=>{ this.headerBounds = e[0].intersectionRect; ob.disconnect(); }); o.observe(this.header); }
    onScroll(){
      const y = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (y > this.currentScrollTop && y > this.headerBounds.bottom){ this.header.classList.add('scrolled-past-header'); if (this.preventHide) return; requestAnimationFrame(this.hide.bind(this)); }
      else if (y < this.currentScrollTop && y > this.headerBounds.bottom){ this.header.classList.add('scrolled-past-header'); if (!this.preventReveal){ requestAnimationFrame(this.reveal.bind(this)); } else { window.clearTimeout(this.isScrolling); this.isScrolling = setTimeout(()=>{ this.preventReveal = false; }, 66); requestAnimationFrame(this.hide.bind(this)); } }
      else if (y <= this.headerBounds.top){ this.header.classList.remove('scrolled-past-header'); requestAnimationFrame(this.reset.bind(this)); }
      this.currentScrollTop = y;
    }
    hide(){ if (this.headerIsAlwaysSticky) return; this.header.classList.add('shopify-section-header-hidden','shopify-section-header-sticky'); this.closeMenuDisclosure(); this.closeSearchModal(); }
    reveal(){ if (this.headerIsAlwaysSticky) return; this.header.classList.add('shopify-section-header-sticky','animate'); this.header.classList.remove('shopify-section-header-hidden'); }
    reset(){ if (this.headerIsAlwaysSticky) return; this.header.classList.remove('shopify-section-header-hidden','shopify-section-header-sticky','animate'); }
    closeMenuDisclosure(){ this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu'); this.disclosures.forEach((d)=>d.close()); }
    closeSearchModal(){ this.searchModal = this.searchModal || this.header.querySelector('details-modal'); this.searchModal && this.searchModal.close(false); }
  }
  customElements.define('sticky-header', StickyHeader);

  /* Drawer ↔ Mega guard */
  (() => {
    const mqDesktop = window.matchMedia('(min-width: 990px)');
    const drawer = document.querySelector('header-drawer details') 
                || document.querySelector('.menu-drawer-container details')
                || document.querySelector('details[role="dialog"]');
    const megas = Array.from(document.querySelectorAll('.as-menu-skin .mega-menu'));
    const closeMegas = () => megas.forEach(d => { try { d.open = false; } catch(e){} });
    const closeDrawer = () => {
      if (!drawer) return;
      try { drawer.open = false; } catch(e){}
      drawer.removeAttribute('open');
      const sum = drawer.querySelector('summary'); if (sum) sum.setAttribute('aria-expanded','false');
    };
    if (drawer) drawer.addEventListener('toggle', () => { if (drawer.open) closeMegas(); });
    megas.forEach(m => m.addEventListener('toggle', () => { if (m.open) closeDrawer(); }));
    mqDesktop.addEventListener('change', (e) => { if (e.matches) { closeDrawer(); } else { closeMegas(); } });
  })();

  /* Move logo into the pill on desktop (always) */
  (() => {
    const mqDesktop = window.matchMedia('(min-width: 990px)');
    const shell = document.querySelector('.section-header');
    if (!shell) return;

    const header = shell.querySelector('.header');
    if (!header) return;

    const menuSkin = header.querySelector('.as-menu-skin');
    if (!menuSkin) return;

    // On home, logo is wrapped in .header__heading; on inner pages it's just the link
    const logoWrapper = header.querySelector('.header__heading');
    const logoLink = header.querySelector('.header__heading-link');
    const logoNode = logoWrapper || logoLink;
    if (!logoNode) return;

    const inlineMenu = menuSkin.querySelector('.header__inline-menu');
    if (!inlineMenu) return;

    const moveLogo = () => {
      if (!mqDesktop.matches) {
        // Mobile / tablet: put logo back before the pill
        if (logoNode.parentElement !== header) {
          header.insertBefore(logoNode, menuSkin);
          logoNode.classList.remove('as-pill-logo');
        }
        return;
      }

      // Desktop: logo becomes first child inside the pill
      if (!inlineMenu.contains(logoNode)) {
        inlineMenu.insertBefore(logoNode, inlineMenu.firstChild);
        logoNode.classList.add('as-pill-logo');
      }
    };

    moveLogo();
    mqDesktop.addEventListener('change', moveLogo);
  })();

  /* Move account + cart icons into the pill on desktop */
  (() => {
    const mqDesktop = window.matchMedia('(min-width: 990px)');
    const shell = document.querySelector('.section-header');
    if (!shell) return;

    const header = shell.querySelector('.header');
    if (!header) return;

    const menuSkin = header.querySelector('.as-menu-skin');
    if (!menuSkin) return;

    const inlineMenu = menuSkin.querySelector('.header__inline-menu');
    if (!inlineMenu) return;

    const iconsContainer = header.querySelector('.header__icons');
    if (!iconsContainer) return;

    const account = header.querySelector('.header__icon--account');
    const cart = header.querySelector('#cart-icon-bubble');

    const moveIcons = () => {
      if (mqDesktop.matches) {
        // Desktop: move account and cart into pill (account then cart)
        if (account && !inlineMenu.contains(account)) {
          inlineMenu.appendChild(account);
          account.classList.add('as-pill-account');
        }
        if (cart && !inlineMenu.contains(cart)) {
          inlineMenu.appendChild(cart);
          cart.classList.add('as-pill-cart');
        }
      } else {
        // Mobile / tablet: move them back into header icons
        if (account && !iconsContainer.contains(account)) {
          iconsContainer.insertBefore(account, iconsContainer.firstChild);
          account.classList.remove('as-pill-account');
        }
        if (cart && !iconsContainer.contains(cart)) {
          iconsContainer.appendChild(cart);
          cart.classList.remove('as-pill-cart');
        }
      }
    };

    moveIcons();
    mqDesktop.addEventListener('change', moveIcons);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-dock-airsupply"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const qs = (s, r=document) => r.querySelector(s);
    const qsa = (s, r=document) => Array.from(r.querySelectorAll(s));

    const backdrop = qs('[data-as-backdrop]');
    const panels = qsa('.as-panel');
    const toggles = qsa('[data-as-toggle]');
    const accs = qsa('[data-as-accordion]');

    function closeAllPanels(){
      panels.forEach(p => p.classList.remove('is-open'));
      toggles.forEach(t => t.setAttribute('aria-expanded','false'));
      backdrop && backdrop.classList.remove('is-open');
    }

    // Open a panel
    toggles.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const id = btn.getAttribute('data-as-toggle');
        const panel = id && document.getElementById(id);
        if (!panel) return;

        const isOpen = panel.classList.contains('is-open');
        closeAllPanels();
        if (!isOpen){
          panel.classList.add('is-open');
          btn.setAttribute('aria-expanded','true');
          backdrop && backdrop.classList.add('is-open');
        }
      }, { passive:false });
    });

    // Close panel actions
    backdrop && backdrop.addEventListener('click', closeAllPanels);
    qsa('[data-as-close]').forEach(x => x.addEventListener('click', closeAllPanels));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAllPanels(); });

    // Accordion (level 1 → level 2) and (level 2 → level 3)
    accs.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const base = btn.getAttribute('data-as-accordion');
        const list = document.getElementById(base + '-list');
        if (!list) return;
        const open = list.classList.contains('is-open');
        // close siblings at same level
        const container = btn.closest('.as-panel__scroll') || btn.closest('.as-sublist') || btn.closest('.as-subsublist');
        if (container){
          Array.from(container.querySelectorAll('.as-sublist, .as-subsublist')).forEach(el => {
            if (el !== list) el.classList.remove('is-open');
          });
          Array.from(container.querySelectorAll('[data-as-accordion]')).forEach(el => {
            if (el !== btn) el.setAttribute('aria-expanded','false');
          });
        }
        // toggle current
        if (open){
          list.classList.remove('is-open');
          btn.setAttribute('aria-expanded','false');
        } else {
          list.classList.add('is-open');
          btn.setAttribute('aria-expanded','true');
        }
      }, { passive:false });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
